import { api } from "../../http";

async function DeleteDataAllLayout(id) {
  try {
    
    const data = await api.delete(`/layout/${id}`);
    return data;


  } catch (e) {
    console.log(e.message);
  }
}

export { DeleteDataAllLayout };
